import React from 'react';
import LocalFilterSubNavbar from './LocalFilterSubNavbar';
import ExperienceFilterSubNavbar from './ExperienceFilterSubNavbar';
import BookingsSubNavbar from './BookingsSubNavbar';
import MessagesSubNavbar from './MessagesSubNavbar';

interface SubBarsProps {
  type?: string;
  transparent?: boolean;
}

function SubBars({ type, transparent }: SubBarsProps) {
  switch (type) {
    case 'experienceFilters':
      return (
        <ExperienceFilterSubNavbar transparent={transparent} />
      );
    case 'localFilters':
      return (
        <LocalFilterSubNavbar />
      );
    case 'messagesNavigation':
      return (
        <MessagesSubNavbar />
      );
    case 'bookingsNavigation':
      return (
        <BookingsSubNavbar />
      );
    default:
      return null;
  }
}

export default SubBars;
